import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=4b9428c4&scoped=true"
import script from "./OrderDetails.vue?vue&type=script&lang=js"
export * from "./OrderDetails.vue?vue&type=script&lang=js"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=4b9428c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9428c4",
  null
  
)

export default component.exports